import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Cotizacion, Habitacion, Hotel } from 'app/models/cotizacion-model';
import { Services } from 'app/servicios.service';
import { ModalController } from '@ionic/angular';
import { TarjetasComponent } from '../tarjetas/tarjetas.component';
import { TransferenciaComponent } from '../transferencia/transferencia.component';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-cotizacion',
  templateUrl: './cotizacion.component.html',
  styleUrls: ['./cotizacion.component.css']
})
export class CotizacionComponent implements OnInit {
  public codigo: string = '';
  public loading = false;
  public msgError = '';
  public Cotizacion: Cotizacion;

  constructor(private API: Services, public location: Location, public modalCtrl: ModalController, private http: HttpClient) { }

  ngOnInit(): void {
    this.loading = true;
    var tittle = this.location.prepareExternalUrl(this.location.path());
    tittle = tittle.replace('/cotizacion/', '');
    let codigo = tittle;
    this.API.getCotizacion(codigo).subscribe(data => {
      if(data.ErrorCode == 200){
        this.Cotizacion = data.Cotizacion;
      }else{
        this.msgError = data.ErrorMsg;
      }
      this.loading = false;
    }, error => {
      this.loading = false;
      this.msgError = 'Ocurrió un error inesperado, intente nuevamente más tarde.'
    });
    this.API.getIP().subscribe(data => {
      
    });
    fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => {
        console.log('Your Public IP Address:', data.ip);
        this.API.registrarVisita(codigo, data.ip, window.navigator.userAgent).subscribe(x => {
          console.log(JSON.stringify(x));
        });
      })
      .catch(error => {
        console.error('Error fetching IP:', error);
      });
  }

  getEstrellas(hotel: Hotel){
    let i = 1;
    let estrellas: Array<number> = new Array<number>();
    do{
      estrellas.push(i);
      i++;
    }while(i <= hotel.CotizacionHotelEstrellas);
    return estrellas;
  }

  async openTarjetas(){
    document.querySelector("body").style.overflow = 'hidden';
    document.getElementById("divCotizacion").scrollIntoView();
    const Modal = await this.modalCtrl.create({
      component: TarjetasComponent
    });
    Modal.present();
    const event: any = await Modal.onDidDismiss();
    document.getElementById("noIncluye").scrollIntoView();
    document.querySelector("body").style.overflow = 'visible';
  }

  async openTransferencia(){
    document.querySelector("body").style.overflow = 'hidden';
    document.getElementById("divCotizacion").scrollIntoView();
    const Modal = await this.modalCtrl.create({
      component: TransferenciaComponent
    });
    Modal.present();
    const event: any = await Modal.onDidDismiss();
    document.getElementById("noIncluye").scrollIntoView();
    document.querySelector("body").style.overflow = 'visible';
  }

  validarCostoNino(hotel: Hotel){
    let mostrar = false;
    hotel.Habitacion.forEach(element => {
      if(element.HabitacionCostoNino > 0){
        mostrar = true;
      }
    });
    return mostrar;
  }

  validarCostoInfante(hotel: Hotel){
    let mostrar = false;
    hotel.Habitacion.forEach(element => {
      if(element.HabitacionCostoInfante > 0){
        mostrar = true;
      }
    });
    return mostrar;
  }

  validarSena(hotel: Hotel){
    let mostrar = false;
    hotel.Habitacion.forEach(element => {
      if(element.HabitacionSena > 0){
        mostrar = true;
      }
    });
    return mostrar;
  }

}
